import { z } from "zod";

export const zStrOptionRole = z.enum(["class", "record", "image"]);
export type ZStrOptionRole = z.infer<typeof zStrOptionRole>;
